import type { MiniAppService } from '@revio/shared';
import { renderAppointmentEngine, initAppointmentEngine } from './appointment';
import { renderCatalogOrderEngine, initCatalogOrderEngine } from './catalog-order';
import { renderRequestRfpEngine, initRequestRfpEngine } from './request-rfp';
import { renderServiceTicketEngine, initServiceTicketEngine } from './service-ticket';

export function renderEngine(service: MiniAppService): string {
  switch (service.engine) {
    case 'appointment':
      return renderAppointmentEngine(service);
    case 'catalog_order':
      return renderCatalogOrderEngine(service);
    case 'request_rfp':
      return renderRequestRfpEngine(service);
    case 'service_ticket':
      return renderServiceTicketEngine(service);
    case 'reservation':
    default:
      return renderAppointmentEngine(service);
  }
}

export function initEngine(service: MiniAppService): void {
  switch (service.engine) {
    case 'appointment':
      initAppointmentEngine(service);
      break;
    case 'catalog_order':
      initCatalogOrderEngine(service);
      break;
    case 'request_rfp':
      initRequestRfpEngine(service);
      break;
    case 'service_ticket':
      initServiceTicketEngine(service);
      break;
    case 'reservation':
    default:
      initAppointmentEngine(service);
      break;
  }
}
